"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const URLs_1 = require("../utility/URLs");
const ArticlesTable_1 = __importDefault(require("../components/ArticlesTable"));
const Filters_1 = require("../components/Filters");
const react_router_dom_1 = require("react-router-dom");
const Paginator_1 = __importDefault(require("../../commonFiles/Paginator"));
function ArticlesIndex(props) {
    const history = (0, react_router_dom_1.useHistory)();
    const [articlesPagination, setarticlesPagination] = react_1.default.useState();
    const [update, setupdate] = react_1.default.useState();
    function deleteArticle(id) {
        if (confirm("هل تود فعلا حدف المقال " + id)) {
            (0, URLs_1.ApiCallHandler)(() => URLs_1.Api.deleteArticle(id), () => setupdate(Math.random()), 'ArticlesIndex deleteArticle', true);
        }
    }
    function fetch(params) {
        return URLs_1.Api.fetchArticles(Object.assign(Object.assign(Object.assign({}, (0, Filters_1.getPaginationParams)(articlesPagination)), { orderById: true, with: ['categories'] }), params));
    }
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("div", { className: 'd-flex align-items-center fs-4 ' },
            react_1.default.createElement("i", { className: "bi bi-journal-text" }),
            react_1.default.createElement("div", { className: 'mx-2' }, "\u0642\u0627\u0626\u0645\u0629 \u0627\u0644\u0645\u0642\u0627\u0644\u0627\u062A")),
        react_1.default.createElement("div", { className: 'bg-white rounded shadow m-3 p-4' },
            react_1.default.createElement("div", { className: 'd-flex ' },
                react_1.default.createElement(Filters_1.TextFilter2, { apiCall: fetch, property: 'title', label: 'عنوان المقال', useState: [articlesPagination, setarticlesPagination] }),
                react_1.default.createElement("div", { className: 'w-50' },
                    react_1.default.createElement(Filters_1.TextFilter2, { apiCall: fetch, property: 'source_url', label: 'رابط الاصلي للمقال', useState: [articlesPagination, setarticlesPagination] })),
                react_1.default.createElement(Filters_1.SelectFilter, { options: [
                        { value: true, name: 'مفعلة' },
                        { value: false, name: 'غير مفعلة' }
                    ], apiCall: fetch, property: 'activated', label: 'حالة التفعيل', useState: [articlesPagination, setarticlesPagination] })),
            react_1.default.createElement(ArticlesTable_1.default, { articles: articlesPagination === null || articlesPagination === void 0 ? void 0 : articlesPagination.data, deleteArticle: deleteArticle }),
            react_1.default.createElement(Paginator_1.default, { update: update, log: 'FETCH articles', apiCall: fetch, useState: [articlesPagination, setarticlesPagination] }))));
}
exports.default = ArticlesIndex;
